import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: unknown
    __fbqInitializedIds?: string[]
  }
}

interface UseMetaPixelOptions {
  /** ID del píxel de Meta. */
  pixelId: string
  /** Evento que se dispara al cargar la página. */
  pageViewEvent: string
}

/**
 * Carga el Meta Pixel (fbevents.js) y dispara el evento de vista de página.
 * Se monta solo en la ruta que lo invoca, no de forma global.
 */
export function useMetaPixel({ pixelId, pageViewEvent }: UseMetaPixelOptions) {
  useEffect(() => {
    /* eslint-disable prefer-rest-params */
    const w = window as Window &
      typeof globalThis & {
        fbq?: any
        _fbq?: any
      }

    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }
      w.fbq = n
      if (!w._fbq) w._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const firstScript = document.getElementsByTagName('script')[0]
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript)
      } else {
        document.head.appendChild(script)
      }
    }

    const initialized = w.__fbqInitializedIds ?? []
    if (!initialized.includes(pixelId)) {
      w.fbq?.('init', pixelId)
      w.__fbqInitializedIds = [...initialized, pixelId]
    }

    w.fbq?.('track', pageViewEvent)
    /* eslint-enable prefer-rest-params */
  }, [pixelId, pageViewEvent])
}
